// extracted by mini-css-extract-plugin
module.exports = {"collapse":"collapse_collapse__1oqrQ"};